module.exports = __webpack_public_path__ + "img/Banner01.e357cd2c.jpg";